import React, { useCallback, useContext, useEffect } from "react";
import { AppContext } from "../../App";
import { environment } from "../../Env_data/environment";
import { fakeApiResponse } from "../fakeResponse";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { urlFetchCalls } from "../../Constant";
import { StepContent } from "@mui/material";
import ErrorBoundary from "./ErrorBoundary";
export const createQuery = (obj, initial = false) => {
  let str = initial ? "?" : "&";
  const arr = Object.entries(obj);
  arr.forEach(([key, val], i) => {
    const isLast = i === arr.length - 1;
    if (val !== "") str += `${key}=${val}${isLast ? "" : "&"}`;
  });

  return str?.length > 1 ? str : "";
};
const DI = (WrappedComponent) => {
  const base_url = environment.BASE_URL;

  const Wrapper = (props) => {
    const navigate = useNavigate();
    const contextData = useContext(AppContext);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const logout = () => {
      contextData.setState({ session: {} });
      localStorage.removeItem(environment.APP_NAME);
      navigate("/login");
    };
    const error = useCallback((msg) => {
      enqueueSnackbar(msg, {
        variant: "error",
      });
    }, [enqueueSnackbar]);
    const success = useCallback((msg) => {
      enqueueSnackbar(msg, {
        variant: "success",
      });
    }, [enqueueSnackbar]);
    const info = useCallback((msg) => {
      enqueueSnackbar(msg, {
        variant: "info",
      });
    }, [enqueueSnackbar]);
    const GET = useCallback(async (url, payload = {}) => {
      payload["auth_id"] = contextData?.state?.session?.id ?? "";
      payload["bearer"] = contextData?.state?.session?.bearer ?? "";
      try {
        const response = await fetch(
          `${base_url + url}` + createQuery(payload, true),
          {
            headers: {
              "User-Agent":
                "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.102 Safari/537.36",
            },
          }
        );
        const data = (await response?.json()) ?? {};
        if (data?.error_code === "re-login") {
          await logout();
          await error(data?.message ?? "Session expired. Please login again.");
        }
        if (!response.ok) {
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
        return data;
      } catch (error) {
        console.error("There was an error!", error);
      }
    }, []);

    const POST = useCallback(async (url, payload) => {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "User-Agent":
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.102 Safari/537.36",
        },
        body: JSON.stringify({
          ...payload,
          auth_id: contextData?.state?.session?.id ?? "",
          bearer: contextData?.state?.session?.bearer ?? "",
        }),
      };
      try {
        const response = await fetch(`${base_url + url}`, requestOptions);

        const data = (await response?.json()) ?? {
          success: false,
          message: "not json type",
        };
        if (data?.error_code === "re-login") {
          await logout();
          await error(data?.message ?? "Session expired. Please login again.");
        }
        // check for error response
        if (!response.ok) {
          console.log("API ERROR");
          // get error message from body or default to response status
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
        return data;
      } catch (error) {
        console.error("There was an error!", error);
      }
    }, []);

    const POST_FORM = useCallback(async (url, formData) => {
      // Append auth credentials to FormData
      formData.append("auth_id", contextData?.state?.session?.id ?? "");
      formData.append("bearer", contextData?.state?.session?.bearer ?? "");
      try {
        const response = await fetch(`${base_url + url}`, {
          method: "POST",
          body: formData, // No Content-Type header - browser sets it with boundary
        });
        const data = (await response?.json()) ?? {
          success: false,
          message: "not json type",
        };
        if (data?.error_code === "re-login") {
          await logout();
          await error(data?.message ?? "Session expired. Please login again.");
        }
        if (!response.ok) {
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
        return data;
      } catch (err) {
        console.error("There was an error!", err);
      }
    }, []);

    const FAKE = useCallback(async (url, payload = {}) => {
      const data = await fakeApiResponse(url);
      return data;
    }, []);

    return (
      <ErrorBoundary>
        <WrappedComponent
          {...props}
          di={{
            contextData,
            session: contextData?.state?.session,
            GET,
            POST,
            POST_FORM,
            FAKE,
            error,
            success,
            info,
            navigate,
            urls: urlFetchCalls,
            logout,
          }}
        />
      </ErrorBoundary>
    );
  };

  return Wrapper;
};

export default DI;
